import { useTranslation } from '@hooks/useTranslation';
import { useAvatarEditor } from '@hooks/useAvatarEditor';
import cn from 'classnames';
import React, { FC, useRef, useState } from 'react';
import AvatarEditor from 'react-avatar-editor';
import s from './avatarBlock.module.scss';
import { SocialManagerView } from '@specs/views';
import { Button } from '@components/UIKit/Button/Button';
import { Avatar } from '@components/UIKit/Avatar/Avatar';
import { useUpdateAvatar } from '@services/social/hooks/useUpdateAvatar';
import { DeleteAvatar } from './DeleteAvatar';
import { useUploadCropperImage } from '@hooks/useUploadCropperImage';
import { useShowToast } from '@hooks/useShowToast';
interface AvatarBlockLoadedProps extends SocialManagerView.publicProfile {}
export const AvatarBlockLoaded: FC<AvatarBlockLoadedProps> = ({
  shortid: shortId,
  avatar
}) => {
  const {
    showToast
  } = useShowToast();
  const {
    translate: tr
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const {
    editorRef,
    picture,
    handleFileChange,
    setDefault,
    setCroppedImg
  } = useAvatarEditor();
  const {
    uploadImage
  } = useUploadCropperImage();
  const {
    mutateAsync: updateAvatarMutate,
    isLoading: isUpdateAvatarLoading
  } = useUpdateAvatar();
  const onSubmit = async () => {
    setIsLoading(true);
    const cropData = setCroppedImg();
    if (cropData.status === 'reject') return;
    const uploadData = await uploadImage(cropData.croppedImg);
    if (uploadData.status === 'success') {
      await updateAvatarMutate({
        fileId: uploadData.intent.fileId
      });
    } else {
      showToast({
        variant: 'error',
        title: 'create.toy.something.is.wrong',
        text: tr({
          id: uploadData.code
        }, {
          type: 'PNG'
        })
      });
    }
    setIsLoading(false);
  };
  const uploadHandler = () => {
    if (!fileInputRef?.current) return;
    fileInputRef.current.click();
  };
  const showChangeLabel = picture.img !== null || !!avatar?.id;
  return <div className={s.avatarBlock} data-sentry-component="AvatarBlockLoaded" data-sentry-source-file="AvatarBlockLoaded.tsx">
            {!picture.cropperOpen ? picture.croppedImg ? <div className={cn(s.avatarBlock__image, '_ibg')}>
                        <img src={picture.croppedImg} alt='new avatar' />
                    </div> : <div className={cn(s.avatarBlock__image)}>
                        <Avatar srcSet={[{
        height: 156,
        width: 156,
        minMedia: 767.98
      }, {
        height: 87,
        width: 87,
        minMedia: 0
      }]} isLoading={false} profile={{
        avatar,
        shortid: shortId
      }} />
                    </div> : picture.img && <div className={s.avatarBlock__image}>
                    <div className={cn(s.avatarBlock__editorBox, '_ibg')}>
                        <AvatarEditor className={s.avatarBlock__editor} image={picture.img} ref={editorRef} borderRadius={500} border={0} width={156} height={156} />
                    </div>
                </div>}
            <div className={s.avatarBlock__buttons}>
                <div className={s.avatarBlock__label}>
                    <input className={s.avatarBlock__input} type='file' accept='image/*' onChange={async e => {
          const file = e?.target?.files?.[0];
          if (!file) return;
          await handleFileChange(file);
        }} ref={fileInputRef} />
                    <Button id={showChangeLabel ? 'change_avatar_button' : 'upload_avatar_button'} size='medium' color='White' icons={{
          left: {
            name: showChangeLabel ? 'photo' : 'upload'
          }
        }} onClick={uploadHandler} data-sentry-element="Button" data-sentry-source-file="AvatarBlockLoaded.tsx">
                        {tr({
            id: showChangeLabel ? 'btn.change.photo' : 'btn.upload.photo'
          })}
                    </Button>
                </div>

                {isUpdateAvatarLoading && <Button id='default_button' size='medium' color='Transparent' disabled={true}>
                        {tr({
          id: 'btn.saved'
        })}
                    </Button>}
                {picture.cropperOpen && <Button id='save_avatar_button' size='medium' color='Black' onClick={onSubmit}>
                        {tr({
          id: 'btn.save'
        })}
                    </Button>}

                {!picture.cropperOpen && !isLoading && avatar && <DeleteAvatar setDefault={setDefault} />}
            </div>
        </div>;
};